function statusClass(status, prefix="label") {
  status = status ? status.toLowerCase() : "";
  if (status === "ongoing" || status === "operational") {
    return `${prefix} ${prefix}-success`;
  } else if (status === "inactive") {
    return `${prefix} ${prefix}-danger`
  } else if (status === "planned") {
    return `${prefix} ${prefix}-default`;
  }

  return `${prefix} ${prefix}-default`;
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function extUrl(url) {
  if (!(url.startsWith("http") || url.startsWith("//"))) {
    return `//${url}`;
  }

  return url;
}

export {statusClass, capitalize, extUrl};